import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { connect } from 'react-redux'
import moment from 'moment'
import ValoresCupos from './ValoresCupos'
import ValoresCircuito from './ValoresCircuito'
import CardValores from './CardValores'
import ValoresEmbarque from './ValoresEmbarque'
import FiltroFecha from './FiltroFecha'

function EstadoElevador (props) {
  const { totalizadorCupos, cdmdTotales, totalStock } = props
  const [asignados, setAsignados] = useState(0)
  const [descargados, setDescargados] = useState(0)
  const [circuito, setCircuito] = useState(null)
  const [filtroTiempo, setFiltroTiempo] = useState('hoy')

  useEffect(() => {
    const hoy = moment(new Date()).format('DD-MM-YYYY')

    if (totalizadorCupos && totalizadorCupos.length > 0) {
      const cantidadAsignados = totalizadorCupos.filter((t) => t.fechaDeEmision === hoy) || 0
      const cantidadHoy = cantidadAsignados.cantidadAsignada || 0
      setAsignados(cantidadHoy)
    }

    if (cdmdTotales && cdmdTotales[0]) {
      setDescargados(cdmdTotales[0].descargados)

      const cantAgrupadas = [
        {
          titulo: 'Sin calar',
          cantidad: cdmdTotales[0].entrePlayaYCalado + cdmdTotales[0].ingresoCompleto
        },
        {
          titulo: 'Calados',
          cantidad: cdmdTotales[0].caladoSinPesarAutorizados + cdmdTotales[0].entreCaladoYBruto
        },
        {
          titulo: 'Con peso bruto',
          cantidad: cdmdTotales[0].entreBrutoYDestare
        },
        {
          titulo: 'Descargados',
          cantidad: cdmdTotales[0].descargados
        }
      ]
      setCircuito(cantAgrupadas)
    }
  }, [totalizadorCupos, cdmdTotales, filtroTiempo])

  return (
    <>
      {/* Filtros */}
      <FiltroFecha filtroTiempo={filtroTiempo} setFiltroTiempo={setFiltroTiempo} />

      <Row className='mb-4'>
        <Col lg={3} md={4} sm={12} className='d-flex flex-column justify-content-between'>
          <div className='mb-3'>
            <ValoresCupos asignados={asignados} descargados={descargados} />
          </div>
          <div>
            <CardValores
              titulo={'Buques Anunciados'}
              cantidad={'000'}
              cardColor={'#4e5789'}
            />
          </div>
        </Col>

        <Col lg={6} md={8} sm={12}>
          <ValoresCircuito circuito={circuito} />
        </Col>

        <Col lg={3} md={12} sm={12} className='d-flex flex-column justify-content-between mt-md-3 mt-lg-0'>
          <div className='mb-3'>
            <CardValores
              titulo={'Stock en Terminal'}
              cantidad={totalStock || '000'}
              cardColor={'#3b4366'}
            />
          </div>
          <div>
            <CardValores
              titulo={'Estado embarque'}
              cantidad={'Inactivo'}
              cardColor={'#2c324e'}
            />
          </div>
        </Col>
      </Row>

      <Row>
        {/* Estado de calado */}
        <Col md={6} sm={12} className='mb-3'>
          <CardValores
            titulo={'Estado de calles de calado'}
            contenido={
              <div style={{ height: '250px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#aaa' }}>
                [ Grafico de calado  ]
              </div>
            }
            cardColor={'#232741'}
          />
        </Col>

        {/* Estado de embarque */}
        <Col md={6} sm={12} className='mb-3'>
          <CardValores
            titulo={'Embarque'}
            contenido={
              <div style={{ height: '250px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#aaa' }}>
                [ Grafico de Embarque ({filtroTiempo}) ]
              </div>
            }
            cardColor={'#232741'}
          />
        </Col>
      </Row>

      <Row className='mt-2'>
        <ValoresEmbarque />
      </Row>
    </>
  )
}

const mapStateToProps = (state) => ({
  cdmdTotales: state.dashboard.cdmdTotales,
  existenciaDiaria: state.dashboard.existenciaDiaria,
  totalizadorCupos: state.cupos.totalizadorCupos,
  totalStock: state.stock.totalStock
})

const withRedux = connect(mapStateToProps, null)
export default withRedux(EstadoElevador)

// import React, { useEffect, useState } from 'react'
// import ValoresCupos from './ValoresCupos'
// import { Col, Row } from 'react-bootstrap'
// import { connect } from 'react-redux'
// import moment from 'moment'
// import ValoresCircuito from './ValoresCircuito'
// import CardValores from './CardValores'
// import ValoresEmbarque from './ValoresEmbarque'

// function EstadoElevador (props) {
//   const { totalizadorCupos, cdmdTotales } = props
//   const [asignados, setAsignados] = useState(0)
//   const [descargados, setDescargados] = useState(0)
//   const [circuito, setCircuito] = useState(null)

//   useEffect(() => {
//     const hoy = moment(new Date()).format('YYYY-MM-DD')
//     if (totalizadorCupos && totalizadorCupos.length > 0) {
//       const cantidadAsignados = totalizadorCupos.filter((t) => t.fechaDeEmision === hoy) || 0
//       const cantidadHoy = cantidadAsignados.cantidadAsignada || 0
//       setAsignados(cantidadHoy)
//     }
//     if (cdmdTotales && cdmdTotales[0]) {
//       setDescargados(cdmdTotales[0].descargados)

//       const cantAgrupadas = [
//         {
//           titulo: 'Sin calar',
//           cantidad: cdmdTotales[0].entrePlayaYCalado + cdmdTotales[0].ingresoCompleto
//         },
//         {
//           titulo: 'Calados',
//           cantidad: cdmdTotales[0].caladoSinPesarAutorizados + cdmdTotales[0].entreCaladoYBruto
//         },
//         {
//           titulo: 'Con peso bruto',
//           cantidad: cdmdTotales[0].entreBrutoYDestare
//         },
//         {
//           titulo: 'Descargados',
//           cantidad: cdmdTotales[0].descargados
//         }
//       ]

//       setCircuito(cantAgrupadas)
//     }
//   }, [totalizadorCupos, cdmdTotales])

//   return (
//     <>
//       <Row>
//         <Col md={3}>
//           <ValoresCupos asignados={asignados} descargados={descargados} />
//           <CardValores
//             titulo={'Buques anunciados'}
//             cantidad={'000'}
//             cardColor={'#4e5789'}
//           />
//         </Col>

//         <Col md={6}>
//           <ValoresCircuito circuito={circuito} />
//         </Col>

//         <Col md={3}>
//           {/* <CardValores
//             titulo={'Stock en terminal'}
//             cantidad={'000'}
//             cardColor={'#4e5789'}
//           />
//           <CardValores
//             titulo={'Stock en terminal'}
//             cantidad={'000'}
//             cardColor={'#4e5789'}
//           /> */}
//         </Col>
//       </Row>
//       <Row>
//         <ValoresEmbarque />

//         <Col md={3}>
//           {/* <CardValores
//             titulo={'Buques anunciados'}
//             //cantidad={buquesAnunciados}
//             cardColor={'#4e5789'}
//           /> */}
//         </Col>

//       </Row>
//     </>
//   )
// }
// const mapStateToProps = (state) => ({
//   cdmdTotales: state.dashboard.cdmdTotales,
//   existenciaDiaria: state.dashboard.existenciaDiaria,
//   totalizadorCupos: state.cupos.totalizadorCupos,
//   totalStock: state.stock.totalStock
// })

// const withRedux = connect(mapStateToProps, null)
// export default withRedux(EstadoElevador)
